import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('agenda.cuenta_bancaria'),
      path: 'masters/society/locations/bankaccounts',
      use_parent_params: true,
      params_required: ['idSociedad', 'idSede', 'idCuenta'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'masters/society/locations/banckaccounts/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
      ]
    }
  ]
}
